// src/authpages/timetables/MicrosoftCalendarUtils.js

/**
 * Mock version of Microsoft Calendar utilities that doesn't require loading external scripts
 * This version uses sample data for demonstration purposes
 */

// Mock successful loading of MSAL library (always returns true)
export const loadMsalLibrary = () => {
    console.log('Using mock Microsoft authentication for demo purposes');
    return Promise.resolve(true);
  };
  
  // Mock MSAL initialization
  export const initMsalForImplicitFlow = () => {
    return {
      // Minimal mock implementation
      getAllAccounts: () => [],
      loginPopup: () => Promise.resolve({ 
        account: { 
          name: 'Demo User',
          username: 'demo@outlook.com' 
        } 
      }),
      acquireTokenSilent: () => Promise.resolve({ accessToken: 'mock-token' }),
      acquireTokenPopup: () => Promise.resolve({ accessToken: 'mock-token' }),
      logoutPopup: () => Promise.resolve()
    };
  };
  
  // Mock login function
  export const loginWithMicrosoft = async () => {
    // Simulate a login delay
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return {
      account: {
        name: 'University Demo',
        username: 'demo@outlook.com'
      }
    };
  };
  
  // Mock token acquisition
  export const getAccessToken = async () => {
    // Simulate a token acquisition delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    return 'mock-access-token';
  };
  
  // Mock calendar events fetch with sample data
  export const fetchMicrosoftCalendarEvents = async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Return sample events
    return generateSampleEvents();
  };
  
  // Generate sample calendar events
  const generateSampleEvents = () => {
    const events = [];
    const today = new Date();
    
    // Sample class events
    const classes = [
      { title: 'Statistics Lecture', color: '#0078D4' },
      { title: 'Database Systems', color: '#50E6FF' },
      { title: 'Engineering Ethics', color: '#0099BC' },
      { title: 'Research Methods', color: '#2D7C9A' },
      { title: 'Team Meeting', color: '#038387' }
    ];
    
    // Generate recurring events for a week
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() + i);
      
      // Don't add events on weekend
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        // Morning class
        const morningClass = classes[i % classes.length];
        const morningStart = new Date(date);
        morningStart.setHours(10, 0, 0);
        const morningEnd = new Date(date);
        morningEnd.setHours(11, 30, 0);
        
        events.push({
          id: `microsoft-morning-${i}`,
          title: morningClass.title,
          start: morningStart,
          end: morningEnd,
          provider: 'Microsoft Calendar',
          color: morningClass.color
        });
        
        // Afternoon class
        const afternoonClass = classes[(i + 2) % classes.length];
        const afternoonStart = new Date(date);
        afternoonStart.setHours(13, 0, 0);
        const afternoonEnd = new Date(date);
        afternoonEnd.setHours(14, 30, 0);
        
        events.push({
          id: `microsoft-afternoon-${i}`,
          title: afternoonClass.title,
          start: afternoonStart,
          end: afternoonEnd,
          provider: 'Microsoft Calendar',
          color: afternoonClass.color
        });
      }
    }
    
    // Add a few one-time events
    const eventTypes = [
      { title: 'Thesis Review', color: '#0078D4' },
      { title: 'Faculty Meeting', color: '#50E6FF' },
      { title: 'Seminar Presentation', color: '#0099BC' },
      { title: 'Department Social', color: '#2D7C9A' },
      { title: 'Study Group Session', color: '#038387' }
    ];
    
    for (let i = 0; i < 5; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() + Math.floor(Math.random() * 7));
      
      const event = eventTypes[i];
      const startHour = 10 + Math.floor(Math.random() * 6);
      
      const start = new Date(date);
      start.setHours(startHour, 0, 0);
      
      const end = new Date(date);
      end.setHours(startHour + 1, 30, 0);
      
      events.push({
        id: `microsoft-event-${i}`,
        title: event.title,
        start: start,
        end: end,
        provider: 'Microsoft Calendar',
        color: event.color
      });
    }
    
    return events;
  };